export const DELETED_ADDRESS_MSG = {
    message: 'Address Deleted',
};
export const ADDED_ADDRESS_MSG = {
    message: 'Address Added',
};
export const EDITED_ADDRESS_MSG = {
    message: 'Changes Saved',
    dataTestId: 'edit-changes-saved-msg',
};
export const CHANGES_SAVED_MSG = {
    message: 'Changes Saved',
    dataTestId: 'changes-saved-msg',
};
export const HD_PASS_SUCCESS_STOP_AUTH_MSG = {
    message: "You've successfully removed HD Pass authorization for this card.",
};
export const PAYPAL_ADDED_MSG = {
    message: 'Account Added',
};
export const INACTIVE_SAVES_MSG = {
    message: 'Card Now Inactive',
    dataTestId: 'inactivate-card-msg',
};
export const INACTIVE_GIFT_CARD_SAVES_MSG = {
    message: 'Gift Card Now Inactive',
};
export const DELETE_GIFT_CARD_MSG = {
    message: 'Gift Card Deleted',
};
export const ACTIVE_SAVES_MSG = {
    message: 'Card Now Active',
    dataTestId: 'activate-card-msg',
};
export const ACTIVE_GIFT_CARD_SAVES_MSG = {
    message: 'Gift Card Now Active',
};
export const DELETED_CARD_MSG = {
    message: 'Card Deleted',
    dataTestId: 'card-deleted-msg',
};
export const ADD_GIFT_CARD = {
    message: 'Gift Card Added',
};
export const CREDIT_CARD_ADDED = {
    message: 'Card Added',
    dataTestId: 'card-added-msg',
};
export const DELETED_ACCOUNT_MSG = {
    message: 'Checking Account Deleted',
};
export const DELETED_PAYPAL_ACCOUNT_MSG = {
    message: 'Account Deleted',
};
export const STOP_ALL_AUTH_SUCCESS_MSG = {
    message: "You've successfully stopped remote purchase approvals for all credit cards on this account.",
};
export const CARD_PHONE_AUTH_AND_T2C_MSG = {
    message: "You've successfully authorized this card for phone and Text2Confirm purchase approvals.",
};
export const CARD_PHONE_AUTH_MSG = {
    message: "You've successfully authorized this card for phone purchase approvals.",
    dataTestId: 'card-phone-auth-msg',
};
export const CARD_T2C_MSG = {
    message: "You've successfully authorized this card for Text2Confirm purchase approvals.",
};
export const PHA_ENROLLING_T2C_SUCCESS_MSG = {
    message: "You've successfully authorized this line of credit for Text2Confirm purchase approvals.",
};
export const PHA_UNENROLLED_T2C_SUCCESS_MSG = {
    message: "You've successfully removed this line of credit from Text2Confirm.",
};
export const STOPPED_CARD_ALL_AUTH_MSG = {
    message: "You've successfully stopped all remote purchase approvals for this card.",
};
export const STOPPED_CARD_PHONE_AUTH_MSG = {
    message: "You've successfully removed Phone Authorization  for this card.",
};
export const STOPPED_CARD_T2C_MSG = {
    message: "You've successfully stopped Text2Confirm purchase approvals for this card.",
};
export const ADD_KEY_TAG = {
    message: 'Keytag Added',
};
export const DELETED_KEY_TAG = {
    message: 'Keytag Deleted',
};
export const ADD_CHECKING_ACCOUNT = {
    message: 'Checking Account Added',
};
export const DELETED_CITI_CARDS_SUCCESS_MSG1 = {
    message: "You've successfully deleted all credit cards associated with Citi Account ID ****",
};
export const DELETED_CITI_CARDS_SUCCESS_MSG2 = {
    message: ' from your account.',
};
export const EXPORT = {
    message: ' data successfully exported. Please check your downloads folder for the file.',
};
export const PRINT = {
    message: ' data is ready to print. Please check your downloads folder for the file.',
};
export const ADD_CITI_CARDS_SUCCESS_MESSAGE_PREFIX = {
    message: "You've successfully added credit cards with Citi Account ID ****",
};
export const ADD_CITI_CARDS_SUCCESS_MESSAGE_POSTFIX = {
    message: ' to your account. It may take a few minutes for all cards to appear.',
};
export const INSTANT_CHECKOUT_ENROLLMENT_SUCCESS = {
    message: "You're enrolled in Instant Checkout. ",
};
export const INSTANT_CHECKOUT_PAYMENT_UPDATE_SUCCESS = {
    message: 'Success! Payment method updated. ',
};
export const INSTANT_CHECKOUT_ADDRESS_UPDATE_SUCCESS = {
    message: 'Success! Delivery address updated. ',
};
export const HD_PASS_SUCCESS_AUTH_MSG = {
    message: "You've successfully authorized this card for HD Pass.",
};
export const INFO_MESSAGE_AUTHORIZE_CARD = {
    message: 'You need to authorize your card to get started with Pro Allowance. Click the action menu next to your card and select “Remote Purchases”.',
};
export const PRO_ALLOW_REMOTE_PURCHASES_SUCCESS_MSG_ONE = {
    message: 'Your card is now authorized for remote purchases and can be',
};
export const PRO_ALLOW_REMOTE_PURCHASES_SUCCESS_MSG_TWO = {
    message: 'used for Pro Allowance.',
};
export const RESEND_INVITE_SUCCESS_MSG = {
    message: 'Text2Confirm invite resent to ',
};
